/**
 * Created by mh on 17/12/12
 */
export const baseUrl = window.location.origin;

// export const routerMode = 'history';
export const routerMode = 'hash';
export const routerHost = routerMode === 'hash' ? baseUrl + "/#" : baseUrl;
export const title = '';
export const wxAppId = "wx49db6e8cef37976e";
export const centerUrl = 'http://www/wxlogin.html';
// export const mobileReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
export const mobileReg = /^1\d{10}$/;

export const bannerList = [
  {url: 'javascript:',src: '../../static/images/ad_2019010201.jpg'},
  {url: 'javascript:',src: '../../static/images/ad_2019010202.jpg'},
  {url: 'javascript:',src: '../../static/images/ad_2019010203.jpg'}
]

export const wxORzfb = (baseUrl.indexOf('wx.') > -1 || baseUrl.indexOf('wxtest.') > -1)? 'wx':'zfb' 


// WEBPACK FOOTER //
// ./src/common/js/config.js